import React, { ReactElement } from 'react'
import { Stack } from '@mindfulchefuk/design-system'
import { NavItem } from '@mindfulchefuk/features/Navigation/components/Header/shared'
import { NavLinkData } from '@mindfulchefuk/features/Navigation/interfaces'
import { trackAnalyticsEvent } from '@mindfulchefuk/utils/analytics/amplitude/amplitudeAdapter'
import { useSignedOutNavDesktopContext } from './context/SignedOutNavDesktopContext'
import { SignedOutNavLinksWithDropdown } from './SignedOutNavDropDown/SignedOutNavLinksWithSubnav'

type TSignedOutNavDesktop = {
  links: NavLinkData[]
}

export const SignedOutNavDesktop = ({
  links,
}: TSignedOutNavDesktop): ReactElement => {
  const { handleCloseDesktopNav, handleOnMouseLeave, setActiveItem } =
    useSignedOutNavDesktopContext()

  const onLinkClicked = (label: string) => {
    trackAnalyticsEvent({
      name: 'nav link clicked',
      data: {
        'link name': label,
        section: 'top nav',
        'page source': 'homepage',
      },
    })
    handleCloseDesktopNav()
  }

  return (
    <Stack
      display={{ base: 'none', lg: 'flex' }}
      ml={20}
      direction="row"
      spacing={20}
      onMouseLeave={() => {
        setActiveItem(null)
        handleOnMouseLeave()
      }}
    >
      {links.map((link) => {
        if (link.subNav) {
          return <SignedOutNavLinksWithDropdown link={link} />
        }

        return (
          <NavItem
            id={link.id}
            key={link.id}
            href={link.href}
            hasSubMenu={false}
            onClick={() => onLinkClicked(link.label)}
            onMouseEnter={() => setActiveItem(null)}
          >
            {link.label}
          </NavItem>
        )
      })}
    </Stack>
  )
}
